function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "0B752E6A-EDA1-4AC8-8680-F931C0444BE7@1x");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "tablet/dashboard-copy-7",
  transform: "translate(-958.000000, -649.000000)"
}, React.createElement("g", {
  id: "protection",
  transform: "translate(949.000000, 634.000000)"
}, React.createElement("g", {
  id: "research-(2)",
  transform: "translate(147.000000, 183.157258)"
}, React.createElement("g", {
  id: "Group-4"
})), React.createElement("path", {
  d: "M182.564516,42.6774194 C189.766331,42.6774194 195.604839,36.8389113 195.604839,29.6370968 C195.604839,22.4352823 189.766331,16.5967742 182.564516,16.5967742 C175.362702,16.5967742 169.524194,22.4352823 169.524194,29.6370968 C169.524194,36.8389113 175.362702,42.6774194 182.564516,42.6774194 Z",
  className: "bubble bubble--1",
  id: "Stroke-9-Copy-8",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M270.883065,203.903226 C278.084879,203.903226 283.923387,198.064718 283.923387,190.862903 C283.923387,183.661089 278.084879,177.822581 270.883065,177.822581 C263.68125,177.822581 257.842742,183.661089 257.842742,190.862903 C257.842742,198.064718 263.68125,203.903226 270.883065,203.903226 Z",
  className: "bubble bubble--2",
  id: "Stroke-11-Copy-8",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M119.733871,277.403226 C126.935685,277.403226 132.774194,271.564718 132.774194,264.362903 C132.774194,257.161089 126.935685,251.322581 119.733871,251.322581 C112.532056,251.322581 106.693548,257.161089 106.693548,264.362903 C106.693548,271.564718 112.532056,277.403226 119.733871,277.403226 Z",
  className: "bubble bubble--3",
  id: "Stroke-13-Copy-8",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M32.3044355,130.995968 C44.5809749,130.995968 54.5322581,121.043931 54.5322581,108.768145 C54.5322581,96.4916057 44.5809749,86.5403226 32.3044355,86.5403226 C20.0286495,86.5403226 10.0766129,96.4916057 10.0766129,108.768145 C10.0766129,121.043931 20.0286495,130.995968 32.3044355,130.995968 Z",
  className: "bubble bubble--4",
  id: "Stroke-15-Copy-8",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("g", {
  className: "shield"
}, React.createElement("path", {
  d: "M171.580092,214.39335 L148.134464,227.033375 L124.691296,214.39335 C99.1801909,200.639397 83.5268228,175.606615 83.5268228,148.563866 L83.5268228,65.8075689 L212.744565,65.8075689 L212.744565,148.563866 C212.744565,175.606615 197.091197,200.639397 171.580092,214.39335 Z",
  id: "Stroke-1-Copy",
  className: "shield-outline",
  stroke: "#FFFFFF",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M129.217742,86.5403226 L110.842742,99.5763069",
  id: "Line-12-Copy-4",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M129.217742,142.258065 L110.842742,155.294049",
  id: "Line-12-Copy-9",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M129.217742,104.322581 L110.842742,117.358565",
  id: "Line-12-Copy-7",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M129.217742,160.040323 L110.842742,173.076307",
  id: "Line-12-Copy-10",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "square"
}), React.createElement("path", {
  d: "M129.217742,124.475806 L110.842742,137.511791",
  id: "Line-12-Copy-8",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  strokeLinecap: "square"
})))));

var SvgIconProtection = function SvgIconProtection(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "276px",
    height: "264px",
    viewBox: "0 0 276 264",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconProtection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-protection.b1864b8e.svg";
export { ForwardRef as ReactComponent };